import React from "react";
import { useLocation } from "react-router-dom";
import { startingPageImg } from "../../assets/images/index";
import { RouterConstant } from "../../routers/index";
import NextButton from "../../components/next-button";
import { useLayoutContext } from "../../layouts/general-layout"; // Import context
import "./uploadcomplete.scss";

export default function Index() {
  const { t } = useLayoutContext(); // Use the context instead of useTranslation
  const { ROUTERS_PATH } = RouterConstant;
  const location = useLocation();
  const { durationMs } = location.state || {};

  const seconds = durationMs != null ? (durationMs / 1000).toFixed(1) : null;

  return (
    <div className="full-head-template uploadcomplete-page">
      <div className="uploadcomplete-body">
        <div className="uploadcomplete-image">
          <img src={startingPageImg} alt="MainImage" />
        </div>
        <div>
          <h4 className="uploadcomplete-title">
            {t("uploadcompletescuesses")}
          </h4>
          {seconds && (
            <p className="upload-time">
              {`Upload Time: ${ seconds }`}
            </p>
          )}
        </div>
      </div>
      <div className="uploadcomplete-action">
        <div>{t("keepinphone")}</div>
        <div>
          <NextButton link={ROUTERS_PATH.LOGIN} />
        </div>
      </div>
    </div>
  );
}
